(function(angular){
	'use strict';
	
	angular
		.module('productPage')
		.controller('VerticalNavCtrl', [
			'globalConfig',
			'urlFactory',
			VerticalNavCtrl
		]);
	
	function VerticalNavCtrl(
		globalConfig,
		urlFactory) {
		
		var navigation = this;

		navigation.modalShown = false;

		navigation.toggleModal = function(state) {
			navigation.modalShown = state;
		};

		navigation.submit = function() {
			var payload = {
				reitOfferingVintageId: globalConfig.reitOfferingVintageId
			};

			urlFactory.postPromise('/add-direct-order-form-to-session.json', payload)
				.then(function(response) {
					urlFactory.redirect('/reits/checkout/start');
				});
		};
	}
})(window.angular);

